import { render } from "./NewTenant.vue?vue&type=template&id=62ce6d7d"
import script from "./NewTenant.vue?vue&type=script&lang=js"
export * from "./NewTenant.vue?vue&type=script&lang=js"

import "./NewTenant.vue?vue&type=style&index=0&id=62ce6d7d&lang=css"
script.render = render

export default script